
import { Container } from "@material-ui/core";

export default function GestRepresentantes({ element: component, ...rest }) {
    // const classes = useStyles()

    return (<Container>{component} </Container>)
}